import React from 'react'

import MainSectionLayout from '@/main-section-layout'
import PageTopBar from '@/page-top-bar'
import Icon from '@/icons'
import GetStartedButton from '@/get-started-button'
import { isMobile } from 'u/common'

import outProductsCasting from './images/outProductsCasting.jpg'
import outProductsVoting from './images/outProductsVoting.jpg'
import outProductsRating from './images/outProductsRating.jpg'

import './styles.css'

const SectionOurProducts = () => (
  <PageTopBar iconName="crown" text="Our products" >
    <MainSectionLayout
      noLogo
      title="Our products"
      about="Grow your audience and revenue. Share content to beauty fans across the globe. We have developed the most advanced digital tools for you in close cooperation with beauty pageants for the past 4 years."
    >
      <div className="flex justify-between mb7">
        <ImageItem
          imgSrc={outProductsCasting}
          text="Casting"
          iconName="masks"
        />
        <ImageItem
          imgSrc={outProductsVoting}
          text="Voting"
          iconName="voting"
        />
        <ImageItem
          imgSrc={outProductsRating}
          text="Judge Rating"
          iconName="rating"
        />
      </div>

      <GetStartedButton />
    </MainSectionLayout>
  </PageTopBar>
)

const ImageItem = ({ imgSrc, iconName, text }) => {
  return (
    <div className="ph2">
      <div className="mb2 mb3-m min-h116">
        <img src={imgSrc} alt="" className="mh300" />
      </div>
      <div className="flex items-center">
        <Icon icon={iconName} height={isMobile ? '14px' : '30px'} className="mr2"/>
        <div className="f12 f9-m f6-l fw5">{text}</div>
      </div>
    </div>
  )
}

export default SectionOurProducts



// WEBPACK FOOTER //
// ./src/components/section-our-products/section-our-products.js